import { useState } from 'react';
import { trpc } from '@/shared/api';
import { useLandingHeroUpload } from './use-landing-hero-upload';

interface UseReplaceLandingHeroImageOptions {
  readonly onSuccess?: () => void;
}

/** 같은 자리의 사진 파일만 새 파일로 바꾼다. 순서는 그대로다. */
export const useReplaceLandingHeroImage = ({
  onSuccess,
}: UseReplaceLandingHeroImageOptions = {}) => {
  const uploader = useLandingHeroUpload();
  const [pendingId, setPendingId] = useState<string | null>(null);
  const mutation = trpc.landing.replaceHeroImage.useMutation({
    onSuccess,
    onSettled: () => setPendingId(null),
  });

  const replaceImage = async (id: string, file: File): Promise<void> => {
    setPendingId(id);
    const imageKey = await uploader.upload(file);

    if (imageKey === null) {
      setPendingId(null);
      return;
    }

    mutation.mutate({ id, imageKey });
  };

  return {
    replaceImage,
    pendingId,
    error: uploader.error ?? mutation.error?.message ?? null,
    /** 지난 업로드·서버 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: () => {
      mutation.reset();
      uploader.clearError();
    },
  };
};
